(() => {
if (window.fwTopupBound) return;
window.fwTopupBound = true;
const root = window.Shopify?.routes?.root || '/';
let generation = 0;
const money = cents => new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'}).format(cents/100);
function choose(cart, catalogue) {
  const gap = Math.max(0,5000-cart.total_price);
  if (!gap || cart.currency !== 'GBP' || !cart.item_count) return null;
  const inCart = new Set(cart.items.map(i=>Number(i.variant_id)));
  const available = catalogue.filter(p=>!inCart.has(Number(p.id)));
  const combos = available.map(p=>[p]);
  const relevant = [];
  for (const handles of [
    ['saffron-gold-elixir-brightening-serum','youth-capsule-advanced-brightening-cream'],
    ['surface-reset-enzyme-powder','saffron-cream-brightening-moisturiser','brightening-mineral-spf']
  ]) {
    const missing = handles.filter(h=>!cart.items.some(i=>i.handle===h));
    const products = missing.map(h=>available.find(p=>p.handle===h));
    if (products.length && products.every(Boolean)) {
      const combo={products,cost:products.reduce((sum,p)=>sum+p.price,0)};
      if(handles.some(h=>cart.items.some(i=>i.handle===h)) && combo.cost>=gap && combo.cost<=gap+1000) relevant.push(combo);
      combos.push(products);
    }
  }
  if(relevant.length) return relevant.sort((a,b)=>a.cost-b.cost)[0];
  return combos.map(products=>({products,cost:products.reduce((sum,p)=>sum+p.price,0)}))
    .filter(c=>c.cost>=gap).sort((a,b)=>a.cost-b.cost || a.products.length-b.products.length)[0] || null;
}
const element = (tag,text,className) => {const el=document.createElement(tag);el.textContent=text;if(className)el.className=className;return el;};
async function refresh() {
  const token=++generation;
  const panels=[...document.querySelectorAll('[data-fw-topup]')];
  if(!panels.length) return;
  try {
    const response=await fetch(root+'cart.js',{cache:'no-store'});
    if(!response.ok) throw new Error('Cart unavailable');
    const cart=await response.json();
    if(token!==generation) return;
    for(const panel of panels){
      const data=panel.nextElementSibling;
      const catalogue=JSON.parse(data.textContent);
      const choice=choose(cart,catalogue);
      panel.replaceChildren();panel.hidden=!choice;
      if(!choice) continue;
      panel.append(element('h3','Complete your basket'));
      const links=element('p','');
      choice.products.forEach((p,i)=>{if(i)links.append(document.createTextNode(' + '));const a=element('a',p.title);a.href=p.url;links.append(a);});
      panel.append(links,element('p','Add '+money(choice.cost)+' · Estimated basket '+money(cart.total_price+choice.cost)));
      const button=element('button',choice.products.length===1?'Add to basket':'Add these products');
      button.type='button';
      button.addEventListener('click',async()=>{
        button.disabled=true;
        try {
          const latestResponse=await fetch(root+'cart.js',{cache:'no-store'});
          if(!latestResponse.ok) throw new Error('Please refresh your basket and try again.');
          const latest=await latestResponse.json();
          const missing=choice.products.filter(p=>!latest.items.some(i=>Number(i.variant_id)===Number(p.id)));
          if(missing.length){
            const added=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:missing.map(p=>({id:p.id,quantity:1}))})});
            const result=await added.json();
            if(!added.ok) throw new Error(result.description || 'These products could not be added. Please check availability.');
          }
          window.location.assign(root+'cart');
        }catch(error){panel.append(element('p',error.message));button.disabled=false;}
      });
      panel.append(button,element('p','Estimate uses current product prices. Any further discounts are checked against the updated basket. Free UK delivery applies at £50 or more after discounts.','fw-topup-note'));
    }
  }catch(error){panels.forEach(p=>{p.hidden=true;});}
}
document.addEventListener('theme:cart:change',refresh);
document.addEventListener('theme:product:added',refresh);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refresh);else refresh();

})();
(() => {
if(window.fwCartExperienceBound)return;window.fwCartExperienceBound=true;
function boot(){
document.addEventListener('submit',e=>{if(e.target.matches('form[action*="cart"]'))e.target.querySelectorAll('input[name="updates[]"][data-id]').forEach(input=>{input.name='updates['+input.dataset.id+']';});},true);

(() => {
 const sync=()=>{const total=document.querySelector('[data-cart-total]');const out=document.querySelector('[data-fw-sticky-total]');if(total&&out&&out.textContent!==total.textContent)out.textContent=total.textContent;const main=document.querySelector('.cart__checkout');const pending=[...document.querySelectorAll('[data-fw-promotional-gift] strong')].some(el=>el.textContent.includes('Updating'));if(main&&pending&&!main.disabled){main.dataset.fwGiftBlocked='true';main.disabled=true;}else if(main&&!pending&&main.dataset.fwGiftBlocked){delete main.dataset.fwGiftBlocked;main.disabled=false;}const sticky=document.querySelector('[data-fw-sticky-checkout]');if(main&&sticky&&sticky.disabled!==main.disabled)sticky.disabled=main.disabled;};
 document.addEventListener('click',e=>{if(e.target.closest('[data-fw-sticky-checkout]')){const main=document.querySelector('.cart__checkout');if(main&&!main.disabled)main.click();}});
 const root=document.querySelector('[data-cart-page]');if(root)new MutationObserver(sync).observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled']});sync();
})();

(() => {
 let timer,busy=false;
 const root=document.querySelector('[data-cart-page]');if(!root)return;
 const base=window.Shopify?.routes?.root||'/';
 const isGift=item=>String(item.properties?._oid||'').startsWith('1211982_');
 const invalid=cart=>{const paid=cart.items.filter(item=>!isGift(item));const paidTotal=cart.total_price-cart.items.filter(isGift).reduce((sum,item)=>sum+item.final_line_price,0);return cart.items.filter(item=>isGift(item)&&(!paid.length||paidTotal<1||item.final_line_price>0));};
 async function clean(){if(busy)return;busy=true;try{let response=await fetch(base+'cart.js',{headers:{Accept:'application/json'}});if(!response.ok)return;let cart=await response.json();if(!invalid(cart).length){if(document.querySelector('[data-fw-promotional-gift]')&&!cart.items.some(isGift))window.location.reload();return;}await new Promise(resolve=>setTimeout(resolve,1000));response=await fetch(base+'cart.js',{headers:{Accept:'application/json'}});if(!response.ok)return;cart=await response.json();const gifts=invalid(cart);if(!gifts.length)return;const updates=Object.fromEntries(gifts.map(item=>[item.key,0]));const result=await fetch(base+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates})});if(result.ok)window.location.reload();}catch(error){console.warn('Gift refresh unavailable');}finally{busy=false;}}
 function schedule(){clearTimeout(timer);timer=setTimeout(clean,800);}
 new MutationObserver(records=>{schedule();}).observe(root,{childList:true,subtree:true});
 document.addEventListener('theme:cart:change',schedule);
setInterval(()=>{if([...document.querySelectorAll('[data-fw-promotional-gift] strong')].some(el=>el.textContent.includes('Updating')))clean();},1500);
schedule();
})();

}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();
